import React from 'react';

import { SVGComponentProps } from './svg.types';

const CreationSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M11.8096 2.02095C12.5414 2.75268 12.5414 3.93907 11.8096 4.6708L6.43735 10.0431C6.08143 10.399 5.59729 10.5967 5.09398 10.5918L3.00528 10.5712C2.3324 10.5646 1.78568 10.0262 1.76881 9.35346L1.71836 7.34175C1.7055 6.82866 1.90366 6.33276 2.26658 5.96985L7.68762 0.548804C8.41936 -0.182934 9.60574 -0.182935 10.3375 0.548803L11.8096 2.02095Z"
          fill={fill}
        />
        <rect x="1.71777" y="12.5427" width="10.9301" height="1.45735" rx="0.728674" fill={fill} />
      </svg>
    </span>
  );
};

export default CreationSVG;
